import { API } from "apis";
import { getViaAuth, responseValidator } from "apis/api";
import { PaginationList } from "core/domain";
import { KuCoinHistory } from "core/domain/kucoin-history/kucoin-history";

export const getAllKuCoinHistory = async (
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<KuCoinHistory>>(
        API.kucoin.history + '/' + page + '/' + itemsPerPageCount + `${query || ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.value) {
                setData(response.value);
            }
        }
    });
};